import configManager from '@/utils/config'

export default {
  async install(app) {
    // 等待配置加载完成
    await configManager.loadConfig()
    
    // 添加全局属性
    app.config.globalProperties.$config = configManager
    
    // 添加全局方法
    app.provide('config', configManager)
    
    // 添加全局指令
    app.directive('config-href', {
      mounted(el, binding) {
        const url = configManager.getFullUrl(binding.value)
        el.href = url
      }
    })
  }
}